export const PAGE = 'orgsEditPackagePage';
export const BILLING_SUBSCRIPTION_FORM = 'billingSubscriptionForm';
export const QUANTITY_LIMITS_FORM = 'quantityLimitsForm';

export const SET_PAGE_DATA = `app/${PAGE}/SET_PAGE_DATA`;
export const DELETE_SOFTWARE_LICENSE = `app/${PAGE}/DELETE_SOFTWARE_LICENSE`;
